import {ChangeDetectorRef, Component, DestroyRef, inject, OnInit} from '@angular/core';
import {distinctUntilChanged} from 'rxjs/operators';
import {FileDetailActivitiesDatasource} from './file-detail-activities.datasource';
import {CirculationSearchService, CirculationTableComponent, CirculationView, FileDetailService} from '|shared';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LabelComponent} from '@icz/angular-essentials';


@Component({
  selector: 'icz-file-detail-activities',
  templateUrl: './file-detail-activities.component.html',
  styleUrls: ['./file-detail-activities.component.scss'],
  imports: [CirculationTableComponent, LabelComponent]
})
export class FileDetailActivitiesComponent implements OnInit {

  private cd = inject(ChangeDetectorRef);
  private searchService = inject(CirculationSearchService);
  private fileDetailService = inject(FileDetailService);
  private destroyRef = inject(DestroyRef);

  dataSource!: FileDetailActivitiesDatasource;

  readonly CirculationView = CirculationView;

  ngOnInit(): void {
    this.fileDetailService.objectId$.pipe(
      distinctUntilChanged(),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(fileId => {
      if (!isNil(fileId)) {
        if (!this.dataSource) {
          this.dataSource = new FileDetailActivitiesDatasource(this.searchService, fileId);
          this.cd.detectChanges();
        }
        else {
          this.dataSource.reload(true);
        }
      }
    });
  }

}
